import {Box, Button, Container, Flex, Image, Text, VStack} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {IProduct} from 'types';

interface Props {
  product: IProduct;
  onClick: (product: IProduct) => void;
}

export const RecommendedProduct: FC<Props> = ({product, onClick}) => {
  const {t} = useTranslation();
  const {name, product_img_for_list_thumbnail, discount_price, id} = product;

  const handleClick = () => {
    onClick(product);
  };

  return (
    <Container
      variant="white-block"
      w={['310px', 'inherit']}
      cursor="pointer"
      border="1px solid transparent"
      onClick={handleClick}
    >
      <VStack spacing="7px" alignItems="flex-start" color={colors.lightBlack} h="full">
        <Flex alignItems="flex-start" flex="1">
          <Image
            mr="15px"
            w="50px"
            borderRadius="10px"
            fallbackSrc="/food_pattern.webp"
            src={product_img_for_list_thumbnail}
            alt={`${id} image`}
          />
          <Box fontSize="14px">
            <Text fontWeight="600" mb="10px" noOfLines={2}>
              {name}
            </Text>
          </Box>
        </Flex>
        <Flex align="center" alignSelf="flex-end">
          <Button
            _focus={{border: 'none'}}
            variant="gray"
            borderRadius="12px"
            h="36px"
            px="12px"
            mx="10px"
            alignSelf="center"
          >
            <Text as="span" fontSize="14px" fontWeight="500">
              + {t('ADD')}
            </Text>
          </Button>
          <Text fontWeight="600">
            {discount_price} {t('CURRENCY')}
          </Text>
        </Flex>
      </VStack>
    </Container>
  );
};
